<template>
  <v-card style="height: 100%">
    <project-flow-navigation-toolbar
      :title="poiName"
    ></project-flow-navigation-toolbar>
    <v-toolbar dark dense>
      <v-tabs v-model="tab">
        <v-tab> Details </v-tab>
        <v-tab> Media </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items
      style="height: calc(100% - 112px); position: relative"
      v-model="tab"
    >
      <v-tab-item style="height: 100%">
        <v-card class="full-height-card">
          <v-card-text>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  dense
                  v-model="poi.name"
                  label="Name"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="poi.poiTypeId" label="Poi Type"></v-text-field>
              </v-col>-->
              <v-col
                v-if="
                  $store.state.UserStore.userRole[0] === 'super_admin' ||
                    'project_admin'
                "
                cols="12"
                sm="6"
                md="4"
              >
                <v-select
                  readonly
                  dense
                  :items="$store.state.PoiStore.poiTypes"
                  v-model="poi.poiTypeId"
                  label="Poi Type"
                  item-text="name"
                  item-value="typeId"
                ></v-select>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  readonly
                  dense
                  v-model="$store.state.PoiStore.selectedType.type.parentType"
                  label="Parent Type"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  readonly
                  dense
                  :items="$store.state.PoiStore.selectedType.availableParents"
                  v-model="poi.parentId"
                  label="Select parent"
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>
            </v-row> -->
            <!-- How this info poi's pins show in the Property Navigator. The
                 setting lives on each pin (mediaData.pois of every DZI it's
                 placed on), so this edits all of them at once. -->
            <v-row v-if="isInfoPoi" class="mt-2">
              <v-col cols="12" md="8">
                <div class="text-subtitle-2">How it shows on images</div>
                <div v-if="!placements.length" class="caption grey--text">
                  Not placed on any image yet - place it with "Edit link areas
                  for pois" on one of the
                  {{ isBuildingInfoPoi ? "building's" : "masterplan's" }}
                  images first.
                </div>
                <template v-else>
                  <div class="caption grey--text">
                    Placed on {{ placements.length }}
                    {{ placements.length === 1 ? 'image' : 'images' }} - this
                    applies to all of them.
                    <span v-if="placementsDiffer" class="amber--text">
                      They're currently set differently; saving makes them all
                      the same.
                    </span>
                  </div>
                  <v-switch
                    v-model="display.showAsLabel"
                    label="Show as label"
                    class="mt-2"
                    dense
                    hide-details
                  ></v-switch>
                  <v-text-field
                    v-model="display.label"
                    :disabled="!display.showAsLabel"
                    :placeholder="poi.name"
                    label="Label text"
                    hint="Leave empty to use the POI name"
                    persistent-hint
                    class="mt-3"
                    dense
                  ></v-text-field>
                </template>
              </v-col>
            </v-row>
          </v-card-text>
          <v-spacer />
          <v-card-actions>
            <v-btn color="red darken-1" @click="deletePoi">Delete</v-btn>
            <v-spacer></v-spacer>
            <v-fade-transition>
              <span
                v-if="hasUnsavedChanges"
                class="caption amber--text d-flex align-center mr-2"
              >
                <v-icon x-small color="amber" class="mr-1"
                  >mdi-circle-medium</v-icon
                >Unsaved changes
              </span>
            </v-fade-transition>
            <v-btn v-if="hasUnsavedChanges" text @click="discard"
              >Discard</v-btn
            >
            <v-btn
              color="blue darken-1"
              :disabled="saveButtonDisabled"
              @click="save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <media ref="media" :media="this.$store.state.MediaStore.media"></media>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import ProjectFlowNavigationToolbar from '../../components/AppBar/ProjectFlowNavigationToolbar'
import Enums from '../../helpers/Enums'
import Media from '../../views/Media'
import PoiService from '../../services/PoiService'
import { MediaGalleryLeaveGuardMixin } from '../../mixins/MediaGalleryLeaveGuardMixin'

export default {
  name: 'PoiExplore',
  mixins: [MediaGalleryLeaveGuardMixin],
  props: {},
  components: {
    ProjectFlowNavigationToolbar,
    Media
  },
  data: function() {
    return {
      title: '',
      tab: null,
      poi: {},
      changeDetected: false,
      // This poi's pins ({ mediaId, mediaName, displayMode, label }), and the
      // one display setting the form edits for all of them.
      placements: [],
      placementsDiffer: false,
      display: { showAsLabel: false, label: '' },
      savedDisplay: { showAsLabel: false, label: '' }
    }
  },
  computed: {
    poiName: function() {
      return this.$store.state.PoiStore.selectedPoi
        ? this.$store.state.PoiStore.selectedPoi.name
        : ''
    },
    isBuildingInfoPoi() {
      return this.poi.poiTypeId === Enums.PoiType.poi_type_building_info
    },
    // Only info pois get pinned on DZIs.
    isInfoPoi() {
      return (
        this.isBuildingInfoPoi ||
        this.poi.poiTypeId === Enums.PoiType.poi_type_masterplan_info
      )
    },
    // Project-wide default (properties.showPoiAsText) that a pin without its
    // own displayMode falls back to in the Property Navigator.
    projectShowsPoisAsLabels() {
      const project = this.$store.state.ProjectStore.selectedProject
      const v =
        project && project.properties && project.properties.showPoiAsText
      return v === true || v === 1 || v === '1'
    },
    displayChanged() {
      return (
        this.display.showAsLabel !== this.savedDisplay.showAsLabel ||
        this.display.label.trim() !== this.savedDisplay.label
      )
    },
    hasUnsavedChanges() {
      return this.changeDetected || this.displayChanged
    },
    saveButtonDisabled: function() {
      return !this.hasUnsavedChanges
    }
  },
  methods: {
    getData: async function(poiId) {
      if (this.$route.params.poiId) {
        await this.$store.dispatch('MediaStore/resetStore')

        await this.$store.dispatch(
          'PoiStore/setSelectedPoi',
          this.$route.params.poiId,
          { root: true }
        )
        this.poi = JSON.parse(
          JSON.stringify(this.$store.state.PoiStore.selectedPoi)
        )
        await this.loadPlacements()
        await this.$store.dispatch('MediaStore/setMediaContext', 'poi')
        await this.$store.dispatch('MediaStore/fetchMediaTypes')
        await this.$store.dispatch('MediaStore/fetchMedia')
      } else {
        return
      }
    },
    // A pin without its own displayMode shows the project-wide default.
    pinShowsAsLabel(placement) {
      return placement.displayMode
        ? placement.displayMode === 'label'
        : this.projectShowsPoisAsLabels
    },
    async loadPlacements() {
      this.placements = []
      this.placementsDiffer = false
      if (this.isInfoPoi) {
        try {
          const resp = await PoiService.getPoiPlacements(this.poi.id)
          this.placements = resp.data.placements || []
        } catch (e) {
          this.$store.dispatch(
            'NotificationStore/add',
            {
              type: 'error',
              message: "Couldn't load where this POI is placed on images."
            },
            { root: true }
          )
        }
      }
      // The form shows the first pin's setting; if the others differ, saving
      // sets them all to what the form shows.
      const first = this.placements[0]
      const shown = {
        showAsLabel: first ? this.pinShowsAsLabel(first) : false,
        label: (first && first.label) || ''
      }
      this.placementsDiffer = this.placements.some(
        p =>
          this.pinShowsAsLabel(p) !== shown.showAsLabel ||
          (p.label || '') !== shown.label
      )
      this.display = { ...shown }
      this.savedDisplay = { ...shown }
    },
    async savePlacements() {
      const label = this.display.label.trim()
      const changes = {}
      // Only send what changed, so pins nobody touched keep falling back to
      // the project default - unless they differ, then everything is set.
      if (
        this.placementsDiffer ||
        this.display.showAsLabel !== this.savedDisplay.showAsLabel
      ) {
        changes.displayMode = this.display.showAsLabel ? 'label' : 'pin'
      }
      if (this.placementsDiffer || label !== this.savedDisplay.label) {
        changes.label = label || null
      }
      await PoiService.updatePoiPlacements(this.poi.id, changes)
    },
    save: async function() {
      if (this.changeDetected) {
        await this.$store.dispatch('PoiStore/updatePoi', this.poi)
        // Updateovanje poia se sada izvrsava u updatePoi akciji:
        // await this.$store.dispatch(
        //   'PoiStore/setSelectedPoi',
        //   this.$route.params.poiId
        // )
        this.poi = JSON.parse(
          JSON.stringify(this.$store.state.PoiStore.selectedPoi)
        )
        this.changeDetected = false
      }
      if (this.displayChanged) {
        try {
          await this.savePlacements()
        } catch (e) {
          this.$store.dispatch(
            'NotificationStore/add',
            {
              type: 'error',
              message: "Couldn't update how this POI shows on images."
            },
            { root: true }
          )
          return
        }
        await this.loadPlacements()
      }
    },
    discard() {
      this.poi = JSON.parse(
        JSON.stringify(this.$store.state.PoiStore.selectedPoi)
      )
      this.changeDetected = false
      this.display = { ...this.savedDisplay }
    },
    deletePoi: async function() {
      this.$confirm({
        title: 'Delete POI',
        text: 'Are you sure?',
        acceptText: 'DELETE',
        cancelText: 'CANCEL'
      })
        .then(y => {
          this.$store
            .dispatch('PoiStore/deletePoi', this.$route.params.poiId)
            .then(
              () => {
                this.$router.go(-1)
                this.$emit('deleted')
              },
              err => {
                this.$store.dispatch(
                  'NotificationStore/add',
                  {
                    type: 'error',
                    message:
                      'Poi has media records attached, it cannot be deleted.'
                  },
                  { root: true }
                )
              }
            )
        })
        .catch(n => {
          console.log('NO')
        })
    }
  },

  created: async function() {},
  mounted: function() {},
  watch: {
    poi: {
      // This will let Vue know to look inside the object
      deep: true,
      handler: function(after, before) {
        if (JSON.stringify(before) !== '{}') {
          this.changeDetected =
            JSON.stringify(this.poi) !==
            JSON.stringify(this.$store.state.PoiStore.selectedPoi)
        }
      }
    },
    tab(newVal, oldVal) {
      this.guardMediaTabSwitch(newVal, oldVal, 1)
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getData(parseInt(to.params.poiId))
    })
  },
  async beforeRouteUpdate(to, from, next) {
    await this.confirmLeaveMediaGalleryIfDirty()
    this.getData(to.params.poiId)
    next()
  },
  async beforeRouteLeave(to, from, next) {
    await this.confirmLeaveMediaGalleryIfDirty()
    next()
  }
}
</script>

<style scoped></style>
